import { render, staticRenderFns } from "./AddSourceComponent.vue?vue&type=template&id=b6c7ef68&"
import script from "./AddSourceComponent.vue?vue&type=script&lang=js&"
export * from "./AddSourceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports